import { IconButton } from "@mui/material";
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { FavouritesContext } from "../favourites/favouritesProvider";
import { IQuestion } from "../types";
import { useAnalytics } from "../firebase/firebase";

interface ToggleFavouritesButtonProps {
    question: IQuestion;
}

const iconStyle = {
    "&:hover": { color: "#000 !important", cursor: "pointer" }
}

export const ToggleFavouritesButton = (props: ToggleFavouritesButtonProps) => {
    const { track } = useAnalytics();
    const { showAddToFavouritesModal: addToChosenFolder, isFavourite, removeFromAllFavourites: removeFromFavourites } = useContextWithGuard(FavouritesContext, "AlbumContext");

    const favourite = isFavourite(props.question.id);

    const clickHandler = (e: any) => {
        e.stopPropagation();

        if (favourite) {
            removeFromFavourites(props.question.id);
            track("favourites.remove", { id: props.question.id, collection: props.question.collection })
        }
        else {
            addToChosenFolder([props.question]);
            track("favourites.add", { id: props.question.id, collection: props.question.collection })
        }
    }

    const style = {
        color: favourite ? "red !important" : "secondary"
    }

    return (
        <IconButton
            title={favourite ? "remove favourite" : "add favourite"}
            aria-label="Example"
            onClick={clickHandler}
            sx={{ ...iconStyle, ...style }}
        >
            <FavoriteIcon />
        </IconButton >
    )
}